export default __webpack_public_path__ + "static/media/google_icon.107a37b4.svg";